import React, { useState, useEffect, Component } from 'react';
import { Link } from 'react-router-dom';
import deleteicon from "../../images/icon/delete.png";
import admin from "../../images/banner/admin.png";
import "bootstrap-icons/font/bootstrap-icons.css";
import axios from 'axios';

function Agreements(){

    const [records, setRecords] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        axios.get("https://api.transnational.ai/api/agreements") 
            .then(response => {
                console.log(response.data)
                setRecords(response.data.agreements);
            })
            .catch(error => {
                console.error('Error fetching records:', error);
            });
    }, []); 

    const handleFilterchange = (event) => {
        setSearchTerm(event.target.value);
    };

    const filteredRecords = records.filter((record) =>
        record.employeename.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const handleDelete = async (id) => {
        try {
          axios.get(`https://api.transnational.ai/api/deleteagreement/${id}`);
          setRecords(records.filter(record => record.id !== id));
        } catch (error) {
          console.error('Error deleting record:', error);
        }
    };

    const servicesStyle = {
        backgroundImage: `url(${admin})`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center center',
        backgroundColor :'#e6f4ff',
        width :'100%',
        height: '33vh',
    };

    return (
        <section style={{ background :'#f4f4f4' }}>
            <section id="bannerSection" style={servicesStyle}>
                <div className="container">
                    <h1 id="HR"></h1>
                </div>
            </section>
            <div className="container" style={{ background :'#ffffff' }}>
                <div className="col-12" style={{ margin:'0 auto'}}>
                    <div className="well well-small" style={{ textAlign:"left" }}>
                        <ul className="media-list">
                            <li className="media well well-small" style={{ marginTop:'10px',marginLeft:'-15px',marginRight:'15px',marginBottom:'-5px'}}>
                                <section className="breadcrumb" style={{ marginLeft:'5px', marginTop:'5px',marginRight:'5px'}}>
                                    <div  className="col-md-12 breadcrumbs" >
                                    <a href="/admin/Dashboard">Home</a> <i class="bi bi-chevron-double-right"></i> <a href="/admin/Dmsdashboard">Document Management System Dashboard</a> <i class="bi bi-chevron-double-right"></i> <span>Documents</span>
                                    </div>
                                </section>
                                <div className="container">
                                    <div className='row'>
                                        <div className="col-sm-9 col-md-9 col-lg-9 pull-left"></div>
                                        <div className="col-sm-3 col-md-3 col-lg-3" style={{ marginLeft:'-20px'}}>
                                            <form >
                                            <input style={{ height:"35px",marginRight:"-5px",width:"255px"}} value={searchTerm} onChange={handleFilterchange} type='text' name='keyword' maxLength={150} placeholder='search Agreement' />
                                            <button class="btn btn-warning" style={{ marginTop:"-5px",backgroundColor:"#ccc",border:"#ccc"}} type="button"><i class="bi bi-search" style={{ fontSize:"10px"}}></i></button>
                                            </form>
                                        </div>
                                    </div> 
                                </div>
                                <div className="media-body" style={{ minHeight : '500px' , padding : '40px',marginTop:"-10px"}}>
                                    <h3 className="media-heading"></h3>
                                    
                                    <table className="mytable">
                                    <thead>
                                        <tr>
                                        <th>Employee Name</th>
                                        <th>Document Title</th>
                                        <th>Created Date</th>
                                        <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    {filteredRecords.map(item => (
                                        <tr  key={item.id}>
                                        <td><Link  to={`/admin/Empagreement/${item.aid}`}>{item.employeename}</Link></td>
                                        <td>{item.documenttitle}</td>
                                        <td>{item.created_at}</td>
                                        <td><button onClick={() => this.handleDelete(item.aid)}><img src={deleteicon} /></button></td>
                                        </tr>
                                    ))} 
                                    </tbody>
                                    </table>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </section>
    );

}

export default Agreements